import styles from "./login.module.scss"
import LoginContainer from "../authentication/login/loginContainer";
import AuthenticationLayout from "../authentication/authenticationLayout";

export default function LoginPage() {
    return <AuthenticationLayout title="Zaloguj się">
            <LoginContainer/>
    </AuthenticationLayout>
}